import styled from 'styled-components';

import { minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	margin-bottom: 32px;
	margin-top: 16px;
	width: 100%;

	${minWidth('desktopLarge')} {
		margin-bottom: 0;
	}
`;
export const AudioElement = styled.audio`
	height: 42px;
`;
